import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';

import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { CurrentAccount } from '../models/AccountModel';
import { UserInfoModel } from '../models/UserInfoModel';
import { AccountDetails } from '../models/AccountDetail';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})


export class NavComponent implements OnInit {

  isBillingRoute: boolean = true;
  isUpdatesRoute: boolean = false;
  isSupportRoute: boolean = false;
  isProfileRoute: boolean = false;
  selectedID: number;
  account: any;
  accountStreetAddress: string;
  accountNumber: string;

  isLoggedIn: boolean;
  acctDetails: AccountDetails[] = [];
  customerInfo: UserInfoModel;
  accountsWithDevices: AccountDeviceModel;
  currentAccount: CurrentAccount;
  public checkPath = (event) => {
    if (event) {
      return;
    }
  }

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private router: Router,
    private ref: ChangeDetectorRef
  ) {
    setInterval(() => {
      this.setup();
    }, 500);
  }

  setBillingRoute() {
    this.isBillingRoute = true;
    this.isUpdatesRoute = false;
    this.isSupportRoute = false;
    this.isProfileRoute = false
  }

  setUpdatesRoute() {
    this.isBillingRoute = false;
    this.isUpdatesRoute = true;
    this.isSupportRoute = false;
    this.isProfileRoute = false
  }

  setSupportRoute() {
    this.isBillingRoute = false;
    this.isUpdatesRoute = false;
    this.isSupportRoute = true;
    this.isProfileRoute = false
  }

  setProfileRoute() {
    this.isBillingRoute = false;
    this.isUpdatesRoute = false;
    this.isSupportRoute = false;
    this.isProfileRoute = true
  }

  switchAccount(id) {
    this.loginService.getUserContext()
      .subscribe((account) => {
        //setting active acctid
        account.activeAcctId = id;
        this.loginService.setUserContextDetail(account);
        let route = this.router.url;
        this.router.navigate([route]).then(() => {
          window.location.reload();
        });
      });
  }


  ngOnInit() {
    let currentUrl = this.router.url; 
    this.checkPath(event);
  }

  setup() {
    this.loginService.getUserIsLoggedIn()
      .subscribe((login) => {
        this.isLoggedIn = login
        this.acctDetails = [];
        if (login) {
          this.loginService.getUserContext()
            .subscribe((account) => {
              this.selectedID = account.activeAcctId;
          });
          this.loginService.getCustomerAccountDetails()
            .subscribe((details: any) => {

              for (let i = 0; i < details.length; i++) {
                this.acctDetails.push(details[i].accountDetails);
              }
              let firstAcct = details[0].accountDetails;


              this.accountStreetAddress = firstAcct.address1 + (firstAcct.address2 !== null ? " " + firstAcct.address2 : "");
              this.accountNumber = firstAcct.accountNumber;
            });
        }
      });
  } 
}





// WEBPACK FOOTER //
// ./src/app/nav/nav.component.ts